import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import V2TopNavbar from "@/components/layout/V2TopNavbar";
import V2BottomNav from "@/components/layout/V2BottomNav";
import { ViewOnlyBanner } from "@/components/groups/ViewOnlyBanner";
import { useMediaQuery } from "@/hooks/use-media-query";
import UIToggle from "@/components/UIToggle";

interface V2LayoutProps {
  children?: ReactNode;
}

const V2Layout = ({ children }: V2LayoutProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground transition-all duration-300 relative">
      <V2TopNavbar />
      <ViewOnlyBanner />

      <main
        className={`flex-1 w-full ${isMobile ? "pb-[calc(4rem+env(safe-area-inset-bottom))]" : ""} relative z-10`}
      >
        <div className="md:py-8 md:px-8 p-4 space-y-6 max-w-[1400px] mx-auto animate-fade-in">
          {children ?? <Outlet />}
        </div>
      </main>

      {isMobile && <V2BottomNav />}
      <UIToggle />
    </div>
  );
};

export default V2Layout;
